// import { useEffect, useContext, useState } from "react";
// import Select from "react-select";
// import { UserContext } from "../contexts/UserContext";
// import authService from "../services/authservices";
// import Switch from "react-switch";

// const options = [
//   { value: "All Pair Selection", label: "All Pair Selection" },
//   { value: "Individual Pair Selection", label: "Individual Pair Selection" },
// ];

// const pairOptions = [
//   {
//     value: "BTC",
//     label: "BTC",
//     img: "https://res.cloudinary.com/dpnvbcrn2/image/upload/v1727086524/u2wxdmltx30nytqc6atj.png",
//   },
//   {
//     value: "ETH",
//     label: "ETH",
//     img: "https://res.cloudinary.com/dpnvbcrn2/image/upload/v1726811012/kbmc7tc1moktarnvgxag.png",
//   },
// ];

// const formatOptionLabel = ({ label, img }) => (
//   <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//     <img
//       src={img}
//       alt={label}
//       style={{ width: "20px", height: "20px", borderRadius: "50%" }}
//     />
//     <span className="bt_outer_span">
//       {label} <span className="bt_inner_span">/USDC</span>
//     </span>
//   </div>
// );

// const BotPopup = ({ handleBotClose }) => {
//   const [activeNum, setActiveNum] = useState(1);
//   const { theme } = useContext(UserContext);
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [checked, setChecked] = useState(false);
//   const handleChange = (nextChecked) => {
//     setChecked(nextChecked);
//   };
//   const [pageLoader, setpageLoader] = useState(false);

//   const customStyles = {
//     control: (styles) => ({
//       ...styles,
//       backgroundColor: theme === "dark" ? "transparent" : "#f9f9f9",
//       border: `1px solid ${theme === "dark" ? "#2b3139" : "#ccc"}`,
//       padding: "4px",
//       color: theme === "dark" ? "#fff" : "#000",
//       boxShadow: "none",
//       outline: "none",
//       fontSize: window.innerWidth < 400 ? "12px" : "16px",
//     }),
//     option: (styles, { isFocused }) => ({
//       ...styles,
//       color: theme === "dark" ? "#fff" : "#000",
//       backgroundColor: isFocused
//         ? theme === "dark"
//           ? "#444"
//           : "#e0e0e0"
//         : theme === "dark"
//         ? "#181a20"
//         : "#fff",
//       cursor: "pointer",
//       fontSize: window.innerWidth < 400 ? "12px" : "16px",
//     }),
//     singleValue: (styles) => ({
//       ...styles,
//       color: theme === "dark" ? "#fff" : "#000",
//       fontSize: window.innerWidth < 400 ? "12px" : "16px",
//     }),
//   };

//    const [tradeNotifications, settradeNotifications] = useState([]);
  
//   const get_trade_notifications = async () => {
//     try {
//       const response = await authService.tradeNotifications();
//       console.log("get_trade_notifications", response);
//       setpageLoader(true);
//       if (response.status) {
//         settradeNotifications(response.data);
//         setpageLoader(false);
//       }
//     } catch (error) {
//       console.error("Error fetching transactions:", error);
//     }
//   };

//   useEffect(() => {
//       let userToken = localStorage.getItem("token");
//       if (userToken == null || userToken == "" || userToken == undefined) {
//       } else {
//         get_trade_notifications();
//       }
//     }, [0]);

//   return (
//     <>
//       <div className="bot_modal_head bot_modal_headnew">
//         <span onClick={handleBotClose} className="bot_modal_close">
//          <i class="fa-solid fa-xmark"></i>
//         </span>
//       </div>

//       <div className="bot_modal_body bot_modal_bodynew">
//           <>
//             <div className="botstatus_imghead">
//               <img
//                 src={require("../assests/trade_inform.webp")}
//                 alt="User"
//                 className="botstatus_imgheadimg"
//               />
//             <h3>Trading Information</h3>
//             </div>

//             <div className="inside_bot_statusbdy">
//                 <div className="inside_tag1">
//                 <h6>Pair</h6>
//                 <h5>ETH/USDC</h5>
//                 </div>
//                 <div className="inside_tag1">
//                 <h6>Price</h6>
//                 <h5>360.43</h5>
//                 </div>
//                 <div className="inside_tag1">
//                 <h6>Quantity</h6>
//                 <h5>0.75</h5>
//                 </div>
               
//               <div className="inside_tag1">
//                 <h6>Status</h6>
//                 <h5 className={'Block' === "Allow" ? "status-allow" : "status-block"}>
//                   Block
//                 </h5>
//               </div>

//                 <div className="inside_tag1">
//                 <h6>Allow Limit</h6>
//                 <h5>5500</h5>
//                 </div>
//                 <div className="inside_tag1">
//                   <h6>Reason</h6>
//                   <h5>Conditions not met</h5>
//                 </div>

//             </div>
           
//           </>

       
//       </div>
//     </>
//   );
// };

// export default BotPopup;


import { useEffect, useContext } from "react";
import useState from "react-usestateref";
import { UserContext } from "../contexts/UserContext";
import authService from "../services/authservices";

const BotPopup = ({ handleBotClose }) => {
  const { theme } = useContext(UserContext);

  const [tradeNotifications, settradeNotifications, tradeNotificationsref] = useState([]);
  const [currentIndex, setCurrentIndex, currentIndexref] = useState(0);

  const [pageLoader, setpageLoader] = useState(false);

  const handleNext = () => {
    if (currentIndexref.current < tradeNotificationsref.current.length - 1) {
      setCurrentIndex(currentIndexref.current + 1);
    } else {
      handleBotClose();      // close popup
      setCurrentIndex(0);     // reset for next time
    }
  };

  const get_trade_notifications = async () => {
    try {
      const response = await authService.tradeNotifications();
      setpageLoader(true);

      if (response.status) {
        settradeNotifications(response.data);
        setpageLoader(false);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

     const closeNotification = async (notify_id) => {
    
      const data = {
        notify_id: notify_id
      };
  
      try {
        const response = await authService.updatetradeStatus(data);
        if (response.status) {
          // get_trade_notifications();
        } else {
        }
      } catch (error) {
      } finally {
      }
    };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    if (userToken) {
      get_trade_notifications();
    }
  }, []);

  // If data is still loading or empty
  // if (pageLoader || tradeNotifications.length === 0) {
  //   return null;
  // }

  // Current popup item
  const item = tradeNotificationsref.current[currentIndexref.current];

  return (
    <>
     {item != null ? (
      <>
      <div className="bot_modal_head bot_modal_headnew">
        <span  
        onClick={() => {
          closeNotification(item._id);
          handleNext();
        }} 
         className="bot_modal_close">
          <i className="fa-solid fa-xmark"></i>
        </span>
      </div>

      <div className="bot_modal_body bot_modal_bodynew">
        <>
          <div className="botstatus_imghead">
            <img
              src={require("../assests/trade_inform.webp")}
              alt="User"
              className="botstatus_imgheadimg"
            />
            <h3>Trading Information</h3>
          </div>

          <div className="inside_bot_statusbdy">
            <div className="inside_tag1">
              <h6>Pair</h6>
              <h5>{item.pair}</h5>
            </div>

            <div className="inside_tag1">
              <h6>Price</h6>
              <h5>{item.price}</h5>
            </div>

            <div className="inside_tag1">
              <h6>Quantity</h6>
              <h5>{item.quantity}</h5>
            </div>

            <div className="inside_tag1">
              <h6>Status</h6>
              <h5
                className={
                  item.status === "Allow" ? "status-allow" : "status-block"
                }
              >
                {item.status}
              </h5>
            </div>

            <div className="inside_tag1">
              <h6>Allow Limit</h6>
              <h5>{item.allowLimit}</h5>
            </div>

            <div className="inside_tag1">
              <h6>Reason</h6>
              <h5>{item.reason}</h5>
            </div>
          </div>
        </>
      </div>
      </>
     ) : (
      <>
      <div className="bot_modal_head bot_modal_headnew">
        <span  
        onClick={() => {
          handleNext();
        }} 
         className="bot_modal_close">
          <i className="fa-solid fa-xmark"></i>
        </span>
      </div>

      <div className="bot_modal_body bot_modal_bodynew">
        <>
          <div className="botstatus_imghead">
            <img
              src={require("../assests/trade_inform.webp")}
              alt="User"
              className="botstatus_imgheadimg"
            />
            <h3>Trading Information</h3>
          </div>

          <div className="inside_bot_statusbdy">
            <div className="inside_tag1">
              <h5>No records found</h5>
            </div>
          </div>
         
        </>
      </div>
       </>
     )}
    </>
  );
};

export default BotPopup;
